import React from "react";
import moment from "moment";
import ExcelJs from "exceljs";
import { EX_REQUEST_API } from "../../ScoreandGrade/SubmitScoring/Apis";
import { openModal } from "../../../../Library/ModalPopUp";
import { StudentIDFormat } from "../../../../Library/GlobalHelper";
import { SessionType } from "../AtdClassList/ConstData";

const DownloadAtdBKD = async (section_id, setStatus) => {
  try {
    setStatus(true);
    const param = { section_id: section_id };
    
    const body = {
        parameters: param,
        target_data: "GET_SECTION",
    };
    const result = await EX_REQUEST_API(body);

    if (result.data && Object.values(result.data).length > 0) {
      const body = {
          parameters: param,
          target_data: "GET_ATD_LECTURER_BY_SECTION_WITH_STUDENT",
      };
      const result_attd = await EX_REQUEST_API(body);
      if (result_attd.data && Object.values(result_attd.data).length > 0) {
        const results = result_attd.data.map((v) => {
          var obj = {};
          obj.atdid = v.id;
          obj.start_dt = v.start_dt;
          obj.end_dt = v.end_dt;
          obj.approved_time = v.approved_time;
          obj.submit_formatted = v.submit_formatted;
          obj.status = v.status;
          obj.teaching_topic = v.teaching_topic ? v.teaching_topic : "-";
          obj.course = v.course;
          obj.emp = v.emp;
          obj.section_id = v.section_id;
          obj.weight = v.weight;
          obj.session_type = v.session_type ? v.session_type : "";

          if (Object.values(v.atd_student).length > 0) {
            const studentLst = v.atd_student.map((s) => {
              if (s.studentstatusdata && s.studentstatusdata.fullname) {
                s.studentstatusdata.fullname = s.studentstatusdata.fullname
                  .split(' ')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  .join(' ');
              }
              var obj2 = {};
              obj2.remark = s.remark ? s.remark : "";
              obj2.status = s.status;
              obj2.studentid = s.studentid;
              obj2.studentname = s.studentstatusdata
                ? s.studentstatusdata.fullname
                : "-";
              return obj2;
            });
            // console.log(v.atd_student);
            // console.log(studentLst);
            studentLst.sort((a, b) => {
              const nameA = a.studentname.toUpperCase() || '';
              const nameB = b.studentname.toUpperCase() || '';
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            });
            obj.studets = studentLst;
          } else {
            obj.studets = [];
          }

          return obj;
        })
        // console.log(results);
        AttdDownload(results, result.data[0]);
      } else {
        openModal({ header:"Error", message: result_attd.message })
      }
    } else {
      openModal({ header:"Information", message: "Norecord found" })
    }

    setStatus(false);
  } catch (error) {
    openModal({ header:"Information", message: "Failed to download. Please try again later." })
    console.log(error);
    setStatus(false);
  }
};


const AttdDownload = (data, section) => {
  const wb = new ExcelJs.Workbook();
  wb.creator = "UMS-SGU";
  wb.lastModifiedBy = "UMS-SGU-System";
  wb.created = new Date();
  wb.modified = new Date();
  wb.lastPrinted = new Date();
  //body here
  SheetAttd(wb, data, section);
  SheetAttdLect(wb, data, section);
  //end body here
  const fileName = "Report Attendance SectionID " + section.section_id;

  const writeFile = (fileName, content) => {
    const link = document.createElement("a");
    const blob = new Blob([content], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
    });
    link.download = fileName;
    link.href = URL.createObjectURL(blob);
    link.click();
  };

  wb.xlsx.writeBuffer().then((buffer) => {
    writeFile(fileName, buffer);
  });
};

const RowHeader = (rowHeader, i, value) => {
  rowHeader.getCell(i).value = value;
  rowHeader.getCell(i).border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };
  rowHeader.getCell(i).fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "191970" },
  };
  rowHeader.getCell(i).alignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true,
  };
  rowHeader.getCell(i).font = {
    bold: true,
    size: 11,
    color: { argb: "FFFFFF" },
  };
}

const SheetAttd = (wb, data, section) => {
  const tableHeader = [
    { key: "A", title: "No", width: 5 },
    { key: "B", title: "Student ID", width: 15 },
    { key: "C", title: "Student Name", width: 35 },
  ];

  const course = section.course;
  const course_title = course.coursetitle.replace(/[^a-zA-Z0-9 ]/g, '');
  const ws = wb.addWorksheet("Attendance Student ");

  const HeaderXLS = BlobImg();
  const imageId1 = wb.addImage({
    fileName: "logo-1",
    extension: "png",
    base64: HeaderXLS.imglogo,
  });
  const imageId2 = wb.addImage({
    fileName: "logo-2",
    extension: "png",
    base64: HeaderXLS.imglogoName,
  });

  ws.addImage(imageId1, "A1:B2");
  ws.addImage(imageId2, "D1:E1");

  let rowNumber = 4;
  ws.getRow(rowNumber).getCell("A").value = "Attendance Report for Section " + section.section_id;
  ws.getRow(rowNumber).getCell("A").font = {
    bold: true,
    size: 16,
  };
  ws.getRow(rowNumber).getCell("A").border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
  };
  ws.getRow(rowNumber).getCell("A").alignment = { horizontal: "center" };
  ws.mergeCells("A" + rowNumber + ":E" + rowNumber);
  rowNumber = rowNumber + 2;

  ws.getRow(rowNumber).getCell("A").value = "Academic Term: " + (section.atp_term && (section.atp_term.name || "-"));
  ws.mergeCells("A" + rowNumber + ":C" + rowNumber);
  rowNumber = rowNumber + 1;

  ws.getRow(rowNumber).getCell("A").value = "Course Title: " + course_title;
  ws.mergeCells("A" + rowNumber + ":C" + rowNumber);
  rowNumber = rowNumber + 1;

  ws.getRow(rowNumber).getCell("A").value = "Course Code: " + course.code;
  ws.mergeCells("A" + rowNumber + ":C" + rowNumber);
  rowNumber = rowNumber + 1;

  ws.getRow(rowNumber).getCell("A").value = "Credit: " + course.credit + " SKS";
  ws.mergeCells("A" + rowNumber + ":C" + rowNumber);
  rowNumber = rowNumber + 1;

  const totalLecturer = Object.values(section.lecturer).length;
  let lecturerName = "";
  if (totalLecturer > 0) {
    section.lecturer.map(item => {
      lecturerName += (item.emp && item.emp.fullname || "-") + "; ";
    })
  }

  ws.getRow(rowNumber).getCell("A").value = "Lecturer: " + lecturerName;
  ws.mergeCells("A" + rowNumber + ":C" + rowNumber);
  rowNumber = rowNumber + 2;

  ws.getRow(6).getCell("D").value = "Generate Date: " + new Date().toLocaleString();
  
  

  const rowHeader = ws.getRow(12);
  tableHeader.map((v, index) => {
    var i = index + 1;
    RowHeader(rowHeader, i, v.title)
  });
  rowNumber = rowNumber + 1;
  
  const total_data = Object.values(data).length;
  if (Object.values(data[total_data-1].studets).length > 0) {
    //column student
    const startRow = 14;
    let rowStudent = startRow;
    var num = 1;
    data[total_data-1].studets.map((v) => {
      const row = ws.getRow(rowStudent);
      let curCell = 1;
      row.getCell(curCell++).value = num++;
      row.getCell(curCell++).value = v.studentid && StudentIDFormat(v.studentid);
      row.getCell(curCell++).value = v.studentname;
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
      rowStudent++;
    });
    ws.mergeCells("A12:A13");
    ws.mergeCells("B12:B13");
    ws.mergeCells("C12:C13");
    //end column student

    //column attendance schd
    const startRowSchd = 12;
    const rowSchd = startRowSchd;
    let columnSchd = 4;
    data.map((v) => {
      const row = ws.getRow(rowSchd);
      RowHeader(row, columnSchd++, (moment(v.start_dt).format("DD MMM YYYY") + "\n" + moment(v.start_dt).format("hh:mm a") + "-" + moment(v.end_dt).format("hh:mm a")))
    });
    //end column attendance schd

    //column teaching topic
    const startRowTopic = 13;
    const rowTopic = startRowTopic;
    columnSchd = 4;
    data.map((v) => {
      ws.getColumn(columnSchd).width = 35;
      const row = ws.getRow(rowTopic);
      RowHeader(row, columnSchd++, "Topic: \n" + v.teaching_topic)
    });
    //end column teaching topic

    //column attendance each student
    const startRowAtd = 14;
    let rowAtd = startRowAtd;
    columnSchd = 4;
    data[total_data-1].studets.map((s) => {
      const row = ws.getRow(rowAtd);
      data.map((a) => {
        const cell = row.getCell(columnSchd++);
        const selectedStd = a.studets.find(
          (item) => item.studentid === s.studentid
        );
        cell.value = selectedStd && (selectedStd.status || "-");
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };
      });

      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      columnSchd = 4;
      rowAtd++;
    });
    //end column attendance each student

    // column status attendance
    const startStatusLabel = rowAtd;
    columnSchd = 1;
    const rowStatusLabel = ws.getRow(startStatusLabel);
    const cellStatusLabel = rowStatusLabel.getCell(columnSchd);
    cellStatusLabel.value = "Status Attendance";
    cellStatusLabel.border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
    cellStatusLabel.alignment = {
      vertical: "middle",
      horizontal: "right",
      wrapText: true,
    };
    cellStatusLabel.font = {
      bold: true,
      size: 11,
    };
    ws.mergeCells("A" + startStatusLabel + ":C" + startStatusLabel);

    const startStatusLabelDate = startStatusLabel + 1;
    columnSchd = 1;
    const rowStatusLabelDate = ws.getRow(startStatusLabelDate);
    const cellStatusLabelDate = rowStatusLabelDate.getCell(columnSchd);
    cellStatusLabelDate.value = "Session Type ";
    cellStatusLabelDate.border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
    cellStatusLabelDate.alignment = {
      vertical: "middle",
      horizontal: "right",
      wrapText: true,
    };
    cellStatusLabelDate.font = {
      bold: true,
      size: 11,
    };
    ws.mergeCells("A" + startStatusLabelDate + ":C" + startStatusLabelDate);

    const rowStatus = rowAtd;
    columnSchd = 4;
    data.map((v) => {
      const row = ws.getRow(rowStatus);
      const cell = row.getCell(columnSchd++);
      cell.value = v.status;
      cell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
      cell.font = {
        bold: true,
        size: 11,
      };
    });

    const rowStatusDate = rowStatus + 1;
    columnSchd = 4;
    data.map((v) => {
      const row = ws.getRow(rowStatusDate);
      const cell = row.getCell(columnSchd++);
      cell.value = v.session_type ? SessionType.find((item) => item.id === v.session_type).name : "-";
      cell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
      cell.font = {
        bold: true,
        size: 11,
      };
    });
  }

  ws.columns.forEach((column, index) => {
    if (index === 0) {
      column.width = 5;
    } else if (index === 1) {
      column.width = 15;
    } else {
      let maxColumnLength = 0;
      column.eachCell({ includeEmpty: true }, cell => {
        let cellLength = cell.value ? cell.value.toString().length : 0;
        if (cellLength > maxColumnLength) {
          maxColumnLength = cellLength;
        }
      });
      column.width = maxColumnLength < 10 ? 10 : maxColumnLength;
    }
  });
};

const SheetAttdLect = (wb, data, section) => {
  const schedules = data;
  const tableHeader = [
    { key: "A", title: "No", width: 5 },
    { key: "B", title: "Start Date", width: 30 },
    { key: "C", title: "End Date", width: 30 },
    { key: "D", title: "Lecturer", width: 30 },
    { key: "E", title: "Teaching Topic", width: 30 },
    { key: "F", title: "Session", width: 15 },
    { key: "G", title: "Submited Date", width: 30 },
    { key: "H", title: "Session Type", width: 10 },
    { key: "I", title: "Status", width: 20 },
  ];

  const course = section.course;
  const course_title = course.coursetitle.replace(/[^a-zA-Z0-9 ]/g, '');
  const ws = wb.addWorksheet("Attendance Lecturer");

  const HeaderXLS = BlobImg();
  const imageId1 = wb.addImage({
    fileName: "logo-1",
    extension: "png",
    base64: HeaderXLS.imglogo,
  });
  const imageId2 = wb.addImage({
    fileName: "logo-2",
    extension: "png",
    base64: HeaderXLS.imglogoName,
  });

  ws.addImage(imageId1, "A1:B2");
  ws.addImage(imageId2, "E2:F2");

  let rowNumber = 4;
  ws.getRow(rowNumber).getCell("A").value = "Attendance Report for Section " + section.section_id;
  ws.getRow(rowNumber).getCell("A").font = {
    bold: true,
    size: 16,
  };
  ws.getRow(rowNumber).getCell("A").border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
  };
  ws.getRow(rowNumber).getCell("A").alignment = { horizontal: "center" };
  ws.mergeCells("A" + rowNumber + ":F" + rowNumber);
  rowNumber = rowNumber + 1;

  ws.getRow(rowNumber).getCell("A").value = "Academic Term: " + (section.atp_term && (section.atp_term.name || "-"));
  ws.mergeCells("A" + rowNumber + ":D" + rowNumber);
  rowNumber = rowNumber + 1;

  ws.getRow(rowNumber).getCell("A").value = "Course Title: " + course_title;
  ws.mergeCells("A" + rowNumber + ":C" + rowNumber);
  rowNumber = rowNumber + 1;

  ws.getRow(rowNumber).getCell("A").value = "Course Code: " + course.code;
  ws.mergeCells("A" + rowNumber + ":C" + rowNumber);
  rowNumber = rowNumber + 1;

  ws.getRow(rowNumber).getCell("A").value = "Credit: " + course.credit + " SKS";
  ws.mergeCells("A" + rowNumber + ":C" + rowNumber);
  rowNumber = rowNumber + 1;

  const totalLecturer = Object.values(section.lecturer).length;
  let lecturerName = "";
  if (totalLecturer > 0) {
    section.lecturer.map(item => {
      lecturerName += (item.emp && item.emp.fullname || "-") + "; ";
    })
  }

  ws.getRow(rowNumber).getCell("A").value = "Lecturer: " + lecturerName;
  ws.mergeCells("A" + rowNumber + ":C" + rowNumber);
  rowNumber = rowNumber + 1;

  ws.getRow(rowNumber).getCell("A").value = "Generate Date: " + new Date().toLocaleString();
  ws.mergeCells("A" + rowNumber + ":C" + rowNumber);
  rowNumber = rowNumber + 2;

  const rowHeader = ws.getRow(rowNumber);
  tableHeader.map((v, index) => {
    var i = index + 1;
    RowHeader(rowHeader, i, v.title)
  });
  rowNumber = rowNumber + 1;

  if (Object.values(schedules).length > 0) {
    schedules.sort((a, b) => a.start_dt > b.end_dt ? 1 : -1);
    let myRow = rowNumber;
    schedules.map((v, index) => {
      const rowTBody = ws.getRow(myRow);
      rowTBody.getCell(1).value = index + 1;
      rowTBody.getCell(2).value = v.start_dt ? moment(v.start_dt).format("DD MMM YYYY hh:mm A") : "";
      rowTBody.getCell(3).value = v.end_dt ? moment(v.end_dt).format("DD MMM YYYY hh:mm A") : "";
      rowTBody.getCell(4).value = v.emp ? v.emp.fullname && v.emp.fullname : "";
      rowTBody.getCell(5).value = v.teaching_topic ? v.teaching_topic : "";
      rowTBody.getCell(6).value = v.weight ? v.weight : "";
      rowTBody.getCell(7).value = v.submit_formatted ? v.submit_formatted : "";
      rowTBody.getCell(8).value = v.session_type ? SessionType.find((item) => item.id === v.session_type).name : "-";
      rowTBody.getCell(9).value = v.status ? v.status : "";

      myRow++;
    })
  }

  ws.columns.forEach((column, index) => {
    if (index === 0) {
      column.width = 5;
    } else if(index === 1 || index === 2) {
      column.width = 20;
    }  else {
      let maxColumnLength = 0;
      column.eachCell({ includeEmpty: true }, cell => {
        let cellLength = cell.value ? cell.value.toString().length : 0;
        if (cellLength > maxColumnLength) {
          maxColumnLength = cellLength;
        }
      });
      column.width = maxColumnLength < 10 ? 10 : maxColumnLength;
    }
  });
};

const BlobImg = () => {
  const imglogo =
      "data:image/png;base64,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";

  const imglogoName =
      "data:image/png;base64,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";

      return {imglogo,imglogoName}
}

export { DownloadAtdBKD };
